import React, { forwardRef, RefObject } from 'react';
import { useState } from 'react';

export type CheckboxWithErrorStatusProps = {
  showError?: boolean;
  value?: boolean;
  onChange: (value: boolean) => void;
  ref?: RefObject<HTMLInputElement>;
  disabled?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const CheckboxWithErrorStatus = React.memo(
  forwardRef<HTMLInputElement, CheckboxWithErrorStatusProps>(
    ({ showError, value, onChange, ...props }, ref) => {
      const [ignoreError, setIgnoreError] = useState(false);
      const changedInternal = (v: boolean, doIgnoreError = true) => {
        setIgnoreError(doIgnoreError && v === true);
        onChange(v);
      };

      return (
        <div>
          <label className="checkbox style-d">
            <input
              data-testid="checkbox-with-error"
              ref={ref}
              type="checkbox"
              onChange={(e) => changedInternal(e.target.checked)}
              checked={value}
              {...props}
            />
            <div
              data-testid="checkbox-with-error-checkmark"
              className={`checkbox__checkmark ${showError && !ignoreError ? 'checkbox-invalid' : ''} ${props.disabled ? 'checkbox-disabled' : ''}`}
            />
          </label>
        </div>
      );
    }
  )
);
